import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Label,
  Button,
  Form,
  Alert,
  FormGroup,
  Modal,
} from "reactstrap"
import { post, del } from "../../helpers/api_helper"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from "react-i18next"
import { useNavigate } from "react-router-dom"
import {
  ADD_PAYMENT_METHOD,
  LANGUAGES_SEARCH,
   UPLOAD_FILE,
} from "../../helpers/api_endpoints"

document.title = "Add Partner"

function AddPaymentMethod() {
  const [status, setStatus] = useState(1)
  const [name, setName] = useState('{"title":[{"1":""}]}')
  const [symbol, setSymbol] = useState("")
  //   const [named, setNamed] = useState("")
  const [languages, setLanguages] = useState([])
  const [errorMsg, seterrorMsg] = useState([])
  const [loading, setLoading] = useState(false)
  const [valued, setValued] = useState({ title: [] })
  const navigate = useNavigate()

  useEffect(() => {
    post(`${LANGUAGES_SEARCH}`, { status: 1 })
      .then(response => {
        setLanguages(response.data)
        // console.log(languages);
        setLoading(false)
      })
      .catch(error => {
        console.log(error)
        // navigate('/collhub');
      })
  }, [])

  const handleSubmit = () => {
    const config = { name, symbol, status }

    post(ADD_PAYMENT_METHOD, config)
      .then(response => {
        if (response.code == 201) {
          navigate("/payment-methods", {
            state: { successMsg: "payment-method Added SuccessFully" },
          })
        }
      })
      .catch(error => {
        seterrorMsg("payment-method Creation Failed")
      })
  }

  const handleName = (languageId, value) => {
    const ln = valued.title.filter(el => {
      return Object.keys(el)[0] == languageId
    })

    if (ln == undefined || ln.length < 1) {
      const ob = {}
      ob[languageId] = value
      valued.title.push(ob)
    } else {
      ln[0][languageId] = value
    }
    setName(JSON.stringify(valued))
  }


  const handleFileUpload = event => {
      setLoading(true)
      const file = event.target.files[0]
      post(
        `${UPLOAD_FILE}`,
        { file, type: "payment-methods", fullPath: "true" },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
        .then(response => {
          const data = response.data
          setSymbol(data.path)
          setLoading(false)
        })
        .catch(error => {})
    }
  

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="Payment Methods"
            breadcrumbItem="Add Payment Method"
          />
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              handleSubmit()
              return false
            }}
          >
            <Row>
              <Col xl={12}>
                <Card>
                  <CardBody>
                    <Row>
                      {languages.map((language, index) => (
                        <Row key={index}>
                          <div className="form-group col-md-4 mt-2">
                            <Label className="form-label">
                              <Trans>Name ({language.name})</Trans>
                            </Label>
                            <Input
                              name="name"
                              // value={name}
                              className="form-control"
                              placeholder="Enter  Name"
                              type="text"
                              onChange={e =>
                                handleName(language.id, e.target.value)
                              }
                              required={
                                language.id == 1 || language.id == 2
                                  ? true
                                  : false
                              }
                            ></Input>
                          </div>
                        </Row>
                      ))}
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Status</Trans>
                        </Label>
                        <select
                          className="form-control"
                          onChange={e => setStatus(e.target.value)}
                          required
                        >
                          <option value=""></option>
                          <option value={1} selected={status == 1}>
                            <Trans>Active</Trans>
                          </option>
                          <option value={0} selected={status == 0}>
                            <Trans>Non Active</Trans>
                          </option>
                        </select>
                      </div>
                      <div className="form-group col-md-4 mt-2">
                        <Label className="form-label">
                          <Trans>Symbol</Trans>
                        </Label>
                        <Input
                          className="form-control"
                          type="file"
                          onChange={handleFileUpload}
                          required
                        ></Input>
                        <img src={symbol} className="w-100" />
                      </div>
                    </Row>
                    <div className="mt-4">
                      <Button type="submit" color="danger">
                        <Trans>Submit</Trans>
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AddPaymentMethod
